import React from "react";
import {
    Card,
    CardContent,
    Typography,
    Box,
    Grid,
    Divider
} from "@mui/material";
import SoftTypography from "../../components/SoftTypography";
import SoftBox from "../../components/SoftBox";
import StatusChip from "../../reusableComponents/status/StatusChip";
import PropTypes from "prop-types";
import BatchActionButtons from "./BatchActionButtons";
import BatchAutoRestartSwitch from "./BatchAutoRestartSwitch";
import { STATUS_STYLES, SUPER_ADMIN } from "../../constants/constants";

const BatchOverviewCard = ({
                               id,
                               role,
                               batchStatus,
                               daemonStatus,
                               deliveryDaemonStatus,
                               qualityCheckDaemonStatus,
                               autoRestart,
                               setAutoRestart,
                               batchName,
                               setNotification,
                               openConfirmation,
                               openSelectOCRTypeConfirmation,
                               fileStatus,
                               pageCount,
                               filesCount
                           }) => {
    const renderStatus = () =>
        Object.entries(fileStatus || {})
            .filter(([_, value]) => value > 0)
            .map(([key, value], index, arr) => {
                const style = STATUS_STYLES[key] || { color: "#000" };

                return (
                    <React.Fragment key={key}>
                        <span style={{ color: style.color }}>
                            {key}: {value}
                        </span>
                        {index < arr.length - 1 && " | "}
                    </React.Fragment>
                );
            });

    return (
        <Card
            sx={{
                borderRadius: 4,
                mb: 4,
                boxShadow:
                    "8px 8px 20px #d1d9e6, -8px -8px 20px #ffffff"
            }}
        >
            <CardContent sx={{ p: 3 }}>
                <Grid container spacing={3} alignItems="center">
                    {/* LEFT SIDE */}
                    <Grid item xs={12} md={8}>
                        <SoftBox display="flex" gap={2} mb={3}>
                            <SoftTypography variant="h5" fontWeight="bold">{batchName}</SoftTypography>
                            <StatusChip status={batchStatus} />
                        </SoftBox>

                        <Divider flexItem />

                        <Typography variant="body2" mb={1}>
                            <strong>Files:</strong> {filesCount}
                            {" | "}
                            <strong>Pages:</strong> {pageCount}
                        </Typography>

                        <Typography variant="body2">
                            {renderStatus()}
                        </Typography>
                    </Grid>

                    {/* RIGHT SIDE */}
                    {role === SUPER_ADMIN && (
                        <Grid item xs={12} md={4}>
                            <Box
                                sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: {
                                        xs: "flex-start",
                                        md: "flex-end"
                                    },
                                    gap: 2
                                }}
                            >
                                <Box
                                    sx={{
                                        display: "flex",
                                        gap: 1,
                                        flexWrap: "wrap",
                                        justifyContent: {
                                            xs: "flex-start",
                                            md: "flex-end"
                                        }
                                    }}
                                >
                                    <BatchActionButtons
                                        id={id}
                                        batchStatus={batchStatus}
                                        daemonStatus={daemonStatus}
                                        deliveryDaemonStatus={
                                            deliveryDaemonStatus
                                        }
                                        qualityCheckDaemonStatus={
                                            qualityCheckDaemonStatus
                                        }
                                        openConfirmation={openConfirmation}
                                        openSelectOCRTypeConfirmation={openSelectOCRTypeConfirmation}
                                    />
                                </Box>

                                <Divider flexItem />

                                <BatchAutoRestartSwitch
                                    id={id}
                                    autoRestart={autoRestart}
                                    setAutoRestart={setAutoRestart}
                                    batchName={batchName}
                                    setNotification={setNotification}
                                />
                            </Box>
                        </Grid>
                    )}
                </Grid>
            </CardContent>
        </Card>
    );
};


BatchOverviewCard.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    role: PropTypes.string.isRequired,
    batchStatus: PropTypes.string.isRequired,
    daemonStatus: PropTypes.string.isRequired,
    deliveryDaemonStatus: PropTypes.string.isRequired,
    qualityCheckDaemonStatus: PropTypes.string.isRequired,
    autoRestart: PropTypes.bool.isRequired,
    setAutoRestart: PropTypes.func.isRequired,
    batchName: PropTypes.string,
    setNotification: PropTypes.func.isRequired,
    openConfirmation: PropTypes.func.isRequired,
    openSelectOCRTypeConfirmation: PropTypes.func.isRequired,
    fileStatus: PropTypes.object,
    pageCount: PropTypes.number,
    filesCount: PropTypes.number
};

export default BatchOverviewCard;